module.exports = __webpack_public_path__ + "static/way_of_mercy-2911d8f0509666c53ccb4568b9d9963e.png";